import { render, staticRenderFns } from "./ConfigAccessUpdateGroupModal.vue?vue&type=template&id=234afc6c&scoped=true"
import script from "./ConfigAccessUpdateGroupModal.vue?vue&type=script&lang=js"
export * from "./ConfigAccessUpdateGroupModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigAccessUpdateGroupModal.vue?vue&type=style&index=0&id=234afc6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234afc6c",
  null
  
)

export default component.exports